<template>
  <div :id="'update_field_' + field.id" class="modal fade rtl" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div :id="'data_sheet_' + field.id" class="modal-body">
          <div class="modal-header">
            <h4 class="modal-title">جزئیات فیلد</h4>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <kt-panel>
            <form @submit.prevent="submitRequest"
                  :id="'single-request-form-' + field.id"
                  class="kt-form p-3 my-4"
            >
              <div class="container text-left p-3 pt-5 my-4 border in-border-header" style="padding-top: 1.5rem !important;">
                <kt-form-section is_first>
                  <div class="section-header">
                    {{ $t('online-factor.create_field') }}
                  </div>
                  <kt-row class="p-2">
                    <kt-col lg="12" md="12" xs="12">
                      <kt-form-group>
                        <kt-form-label :for="'fa_name' + field.id">
                          {{ $t('online-factor.field_name') }}
                          <span class="text-danger h5 pb-3">*</span>
                        </kt-form-label>
                        <kt-form-control :id="'name_' + field.id" name="name" v-model="field.name">
                        </kt-form-control>
                      </kt-form-group>
                    </kt-col>
                    <kt-col lg="12" md="12" xs="12">
                      <kt-form-group>
                        <kt-form-label :for="'fa_name_' + field.id">
                          {{ $t('online-factor.field_fa_name') }}
                          <span class="text-danger h5 pb-3">*</span>
                        </kt-form-label>
                        <kt-form-control :id="'fa_name_' + field.id" name="fa_name" v-model="field.fa_name">
                        </kt-form-control>
                      </kt-form-group>
                    </kt-col>
                    <kt-col lg="12" md="12" xs="12">
                      <kt-form-group>
                        <kt-form-label :for="'type_' + field.id">
                          {{ $t('online-factor.field_type') }}
                          <span class="text-danger h5 pb-3">*</span>
                        </kt-form-label>
                        <select :id="'type_' + field.id" class="form-control" name="type" v-model="field.type">
                          <option
                              v-for="type in fieldTypes"
                              :key="type.value"
                              :value="type.value"
                          >
                            {{type.fa_name}}
                          </option>
                        </select>
                      </kt-form-group>
                    </kt-col>
                    <kt-col lg="12" md="12" xs="12">
                      <kt-form-group>
                        <kt-form-label for="type">
                          {{ $t('online-factor.default_status') }}
                        </kt-form-label>
                        <select id="type" class="form-control" name="default_status" v-model="default_status.data">
                          <option
                              v-for="status in fieldStatus"
                              :key="status.name"
                              :value="status.name"
                          >
                            {{status.fa_name}}
                          </option>
                        </select>
                      </kt-form-group>
                    </kt-col>
                    <kt-col lg="12" md="12" xs="12">
                      <kt-form-group class="d-flex justify-content-between align-items-center w-50">
                        <kt-form-label for="type" class="mt-1">
                          {{ $t('online-factor.disable') }}
                          <span class="text-danger h5 pb-3">*</span>
                        </kt-form-label>
                        <input id="type" type="checkbox" class="check-mark" name="disable" v-model="disable.data">
                      </kt-form-group>
                    </kt-col>
                    <kt-col
                        lg="12" md="12" xs="12"
                        v-if="default_value.data || [
                            fieldTypesConstants.DATE,
                            fieldTypesConstants.SELECT,
                        ].includes(field.type)"
                    >
                      <kt-form-group>
                        <kt-form-label :for="'default_value_' + field.id">
                          {{ $t('online-factor.default_value') }}
                        </kt-form-label>
                        <input
                            type="text"
                            class="form-control"
                            :id="'default_value_' + field.id"
                            name="default_value"
                            aria-describedby="basic-addon1"
                            v-model="default_value.data"
                        />
                      </kt-form-group>
                    </kt-col>
                    <kt-col
                        lg="12" md="12" xs="12"
                        v-if="placeholder.data || [
                          fieldTypesConstants.STRING,
                          fieldTypesConstants.NUMERIC,
                          fieldTypesConstants.TEXT,
                          fieldTypesConstants.DATE,
                        ].includes(field.type)"
                    >
                      <kt-form-group>
                        <kt-form-label :for="'placeholder_' + field.id">
                          {{ $t('online-factor.placeholder') }}
                        </kt-form-label>
                        <input
                            type="text"
                            class="form-control"
                            :id="'placeholder_' + field.id"
                            name="placeholder"
                            aria-describedby="basic-addon1"
                            v-model="placeholder.data"
                        />
                      </kt-form-group>
                    </kt-col>
                    <kt-col
                        lg="12" md="12" xs="12"
                        v-if="options.data || field.type === fieldTypesConstants.SELECT"
                    >
                      <div class="d-flex flex-column">
                        <div class="d-flex justify-content-between align-items-center mb-4">
                          <kt-form-label :for="'options_list_' + field.id">
                            {{ $t('online-factor.options_list') }}
                          </kt-form-label>
                          <button
                              type="button"
                              class="btn btn-success mt-2"
                              @click="addOption"
                          >
                            افزودن گزینه جدید
                          </button>
                        </div>
                        <div v-for="(option, index) in options.data" :key="index" class="d-flex align-items-center justify-content-between my-1">
                          <input
                              name="options"
                              v-model="options.data[index]"
                              type="text"
                              class="form-control w-75 mx-2"
                              :placeholder="'Option ' + (index + 1)"
                          />
                          <button
                              type="button"
                              class="btn-sm btn-danger"
                              @click="removeOption(index)"
                          >
                            حذف
                          </button>
                        </div>
                      </div>
                    </kt-col>
                    <kt-col class="mt-4">
                      <button :id="'submit-button-' + field.id" type="submit" class="btn btn-primary">بروز رسانی</button>
                    </kt-col>
                  </kt-row>
                </kt-form-section>
              </div>
            </form>
          </kt-panel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/elements/button.vue";
import Create_field from "@/views/online-factor/Create_field_form.vue";
import {fieldTypes, fieldTypesConstants} from "@/constants/CustomerFormatFieldTypes";
import toastr from "toastr";
import placeholder from "lodash/fp/placeholder";
import $ from "jquery";
import {onlineFactorService} from "@/common/api.service";
import {fieldOptions} from "@/constants/CustomerFormatFieldOptions";

export default {
  name: "UpdateFieldModal" ,
  components: {Create_field, Button},
  data() {
    return {
      default_value: {
        type: 'default_value',
        data: '',
      },
      placeholder: {
        type: 'placeholder',
        data: '',
      },
      options: {
        type: 'options',
        data: []
      },
      default_status: {
        type: 'default_status',
        data: ''
      },
      disable: {
        type: 'disable',
        data: false
      }
    }
  },
  props: {
    field: {
      required: true
    },
    datatable: {
      required: true,
    }
  },
  computed: {
    fieldTypes() {
      return fieldTypes
    },
    fieldTypesConstants() {
      return fieldTypesConstants
    },
    fieldStatus() {
      return fieldOptions
    },
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }

      return toastr
    },
  },
  mounted() {
    if (this.field.details) {
      this.default_value.data = this.field.details.some(i => i.type === 'default_value') ?
          this.field.details.find(i => i.type === 'default_value').data : null
      this.placeholder.data = this.field.details.some(i => i.type === 'placeholder') ?
          this.field.details.find(i => i.type === 'placeholder').data : null
      this.options.data = this.field.details.some(i => i.type === 'options') ?
          this.field.details.find(i => i.type === 'options').data : []
      this.default_status.data = this.field.details.some(i => i.type === 'default_status') ?
          this.field.details.find(i => i.type === 'default_status').data : ''
      this.disable.data = this.field.details.some(i => i.type === 'disable') ?
          this.field.details.find(i => i.type === 'disable').data : false
    }
  },
  methods: {
    removeOption(index) {
        this.options.data.splice(index, 1);
    },
    addOption() {
      this.options.data.push("");
    },
    submitRequest(e) {
      let form = $(e.target)

      form.validate({
        rules: {
          name: {
            required: true,
            minlength: 3
          },
          fa_name: {
            required: true,
            minlength: 3
          },
          type: {
            required: true,
          },
        }
      })

      if (this.type === fieldTypesConstants.SELECT && this.options.data.length < 2 ) {
        return this.toastr.error('برای فیلد انتخابی حداقل لیست انتخابی باید بیشتر از یک عدد باشد.')
      }

      if (!form.valid()) {
        return;
      }

      let details = []
      if (this.default_value && this.default_value.data)
        details.push(this.default_value)

      if (this.placeholder && this.placeholder.data)
        details.push(this.placeholder)

      if (this.options && this.options.data.length > 0)
        details.push(this.options)

      if (this.disable && this.disable.data)
        details.push(this.disable)

      if (this.default_status && this.default_status.data)
        details.push(this.default_status)


      let data = {
        name: this.field.name,
        fa_name: this.field.fa_name,
        type: this.field.type,
        details: details,
      }

      onlineFactorService.adminUpdateField(this.field.id, data)
          .then(response => {
            $(`#update_field_${this.field.id}`).modal('hide')
            this.datatable.reload()
            return this.toastr.success(response.data.message)
          }).catch(({response}) => {
            this.toastr.error(response.data.message)
            for (let err in response.data.data) {
              this.toastr.error(response.data.data[err][0]);
            }
          })
    }
  }
}
</script>

<style scoped>

</style>